import { Client } from '@core/models/client.models';
import { EntityState } from '@ngrx/entity';

export interface ClientsState extends EntityState<Client> {
  isLoaded: boolean;
  isLoading: boolean;
  selected: string;
}
